import React from "react";
import Modal from "material-ui/Modal";
import Paper from "material-ui/Paper";
import Button from "material-ui/Button";
import Icon from "material-ui/Icon";
import Typography from "material-ui/Typography";
import { withStyles } from "material-ui/styles";
import styles from "./styles";
import { Link } from "react-router-dom";
import Ping from "../../../../subtestsetting/ping";
import ConfirmDialog from "../../../../common/dialog/confirm";

import {
  ModalHeader,
  ModalContents,
  ModalFooter
} from "../../../../common/modal";

class PINGEdit extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      editSaving: false,
      errors: {},
      selected: {},
      error: null,
      modalOpen: false,
      showCloseConfirm: false,
      selectedTestResult: null,
      subTestTargetResult: []
    };
    this.handleClose = this.handleClose.bind(this);
  }

  handleClose() {
    // this.setState({
    //   showCloseConfirm: true
    // });
    this.props.handleClose(this.props.selectedTest);
  }
  onTestCreationCancel = () => {
    this.setState({
      showCloseConfirm: true
    });
  };

  onCloseConfirm = () => {
    this.props.handleClose(this.props.selectedTest);
  };

  onCloseCancelConfirmModal = () => {
    this.setState({
      showCloseConfirm: false
    });
  };

  // onCloseConfirm = () => {
  //   this.props.handleClose(this.props.selectedTest);
  // };

  // onCloseCancelConfirmModal = () => {
  //   this.setState({
  //     showCloseConfirm: false
  //   });
  // };

  selectedRows = rows => {
    this.setState({
      selected: rows
    });
  };
  render() {
    const { translate, classes, selectedTest, testEdit, modified, deviceid } = this.props;
    let { targetList } = this.props;
    const {
      showCloseConfirm,
      selectedTestResult,
      subTestTargetResult
    } = this.state;

    return selectedTest && selectedTest.length ? (
      <Modal
        open={true}
        onClose={this.handleClose}
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center"
        }}
      >
        <div className={classes.root}>
          <Paper className={classes.modal}>
            <ModalHeader>
              <Typography
                type="headline"
                color="inherit"
                className={classes.modalHeader}
              >
                {testEdit
                  ? translate("test_edit_title").toUpperCase()
                  : translate("test_add").toUpperCase()}
              </Typography>
              <Button
                className={classes.close}
                onClick={this.onTestCreationCancel}
              >
                <Icon> clear </Icon>
              </Button>
            </ModalHeader>
            <ModalContents className={classes.rootModal}>
              <Ping
                selectedTest={this.props.selectedTest}
                translate={this.props.translate}
                selectedTestResult={selectedTestResult}
                subTestTargetResult={subTestTargetResult}
                getPingDetails={this.props.getPingDetails}
                getPingTargetList={this.props.getPingTargetList}
                updateTestPingDetails={this.props.updateTestPingDetails}
                handleClose={this.handleClose}
                isTestEdit={true}
                //showRestore={showRestore}
                onRestoreDetails={this.props.onRestoreDetails}
                //isDetailsUpdated={this.props.isDetailsUpdated}
                ping4Details={this.props.ping4Details}
                ping6Details={this.props.ping6Details}
                deleteDefaultSubtests={this.props.deleteDefaultSubtests}
                customerId={this.props.customerId}
                showCloseConfirm={this.state.showCloseConfirm}
                onCloseConfirm={this.onCloseConfirm}
                onCloseCancelConfirmModal={this.onCloseCancelConfirmModal}
                testEdit={testEdit}
                modified={modified}
                deviceid={deviceid}
              />
            </ModalContents>
          </Paper>
        </div>
      </Modal>
    ) : null;
  }

  componentWillReceiveProps(nextProps) {
    const {
      customerTargets4,
      customerTargets6,
      selectedTestResult,
      subTestTargetResult,
      selectedTrResult,
      subTestPingUpdated,
      subTestIpvUpdated,
      netScan,
      upTime,
      maxThroughPut,
      wireMap,

      cableList,

      subtestSettings
    } = nextProps;
    if (
      selectedTestResult &&
      this.props.selectedTestResult != selectedTestResult
    ) {
      this.setState({ selectedTestResult });
    }
    if (
      subTestTargetResult &&
      this.props.subTestTargetResult != subTestTargetResult
    ) {
      this.setState({ subTestTargetResult });
    }
  }
}

export default withStyles(styles)(PINGEdit);
